import React, { Component } from 'react';
import { BrowserRouter as Router,  Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import PersistGate from "./components/PersistGate";
import Content from "./components/Content";
import Navigation from "./components/Navigation";
import ScrollToTop from "./components/ScrollToTop";
import './App.css';
import './Animations.css';
import configureStore from "./configureStore";

const store = configureStore();


class App extends Component {
  render() {
    return <Provider store={store}>
      <PersistGate>
        <Router>
          <ScrollToTop>
            <div>
              <Route exact path="/" component={Navigation} />
              <Route path="/:selectedTile" component={Content} />
            </div>
          </ScrollToTop>
        </Router>
      </PersistGate>
    </Provider>;
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js